import { Splitter as AntSplitter, SplitterProps } from 'antd';

export const Splitter = AntSplitter;

export type { SplitterProps };
